import React, { useContext } from 'react';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from '@headlessui/react';
import { ChevronDown } from '../../components/ui/Icons';
import ProductContext from '../../contexts/ProductContext';
import { MandatoryVariant, Size } from '../../types/components';

export default function MandatoryVariants({
  selectedMandatoryVariant,
  selectedSize,
  handleMandatoryVariantChange,
  handlePricesChange,
}: {
  selectedMandatoryVariant: MandatoryVariant,
  selectedSize: Size,
  handleMandatoryVariantChange: (variant: MandatoryVariant) => void,
  handlePricesChange: (priceObject: {
    price: string,
    promotionalPrice: string,
    onPromotion: boolean,
  }) => void,
}) {
  const { product, mandatoryVariants } = useContext(ProductContext);
  const { mandatoryProductsLabel } = product;

  if (Object.values(mandatoryVariants).length > 1) {
    return (
      <Menu as="div" className="filter-dropdow z-40 relative mb-4">
        <MenuButton className="dropdown-opener dropdown-opener-lg btn btn-outline-dark w-full text-lg lg:text-xl leading-none py-4 px-6">
          <span className="flex gap-x-3 items-center flex-1.0 font-normal">
            <span className="font-semibold">{`${mandatoryProductsLabel}:`}</span>
            <span>{selectedMandatoryVariant.title}</span>
          </span>
          <ChevronDown />
        </MenuButton>
        <MenuItems
          modal={false}
          className="absolute max-h-60 overflow-x-hidden overflow-y-auto bg-white top-full left-0 min-w-full w-max max-w-72 py-1 lg:pr-6 gap-y-2.5 shadow-md rounded"
        >
          <ul>
            {Object.values(mandatoryVariants).map((mandatoryVariant) => (
              <MenuItem as="li" key={mandatoryVariant.title} className="group">
                <button
                  type="button"
                  className={`w-full px-6 py-2 text-left text-lg lg:text-xl leading-normal underline decoration-1 decoration-transparent transition-all hover:decoration-current group-has-[.active]:text-accent${selectedMandatoryVariant.id === mandatoryVariant.id ? ' active' : ''}`}
                  onClick={() => {
                    handleMandatoryVariantChange(mandatoryVariant);
                    handlePricesChange({
                      price: selectedSize.price + mandatoryVariant.price,
                      promotionalPrice:
                        selectedSize.promotionalPrice + mandatoryVariant.salePrice,
                      onPromotion: selectedSize.onPromotion,
                    });
                  }}
                >
                  {mandatoryVariant.title}
                </button>
              </MenuItem>
            ))}
          </ul>
        </MenuItems>
      </Menu>
    );
  }

  if (selectedMandatoryVariant) {
    return (
      <div className="filter-dropdown z-20 relative mb-4 btn btn-outline-dark w-full text-lg lg:text-xl leading-none py-4 px-6">
        <span className="flex gap-x-3 items-center flex-1.0 font-normal">
          <span className="font-semibold">{`${mandatoryProductsLabel}:`}</span>
          <span>{selectedMandatoryVariant.title}</span>
        </span>
      </div>
    );
  }

  return null;
}
